var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('v-select',{attrs:{"outlined":"","dense":"","items":_vm.statuses,"label":_vm.$t('status')},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }